import React from 'react';
import EditableTable from 'src/views/admin/EditableTable';
import {ColumnSettings} from 'src/views/admin/EditableTable/types';
import {Box} from '@mui/material';
import CheckedValue from 'src/views/admin/CheckedValue';

const ABILITIES = [
  {
    name: 'canImpersonateAllUsers',
    title: 'Impersonation',
  },
  {
    name: 'canManageCollegeRanks',
    title: 'College Ranks',
  },
  {
    name: 'canEditFeatureFlags',
    title: 'Feature Flags',
  },
  {
    name: 'canDeleteUsers',
    title: 'Delete Users',
  },
  {
    name: 'canManageInternalUsers',
    title: 'Internal Users',
  },
  {
    name: 'canManageSftpUsers',
    title: 'SFTP Users',
  },
];

const columns: ColumnSettings[] = [
  {
    name: 'email',
    title: 'Email',
    sortable: true,
  },
  ...ABILITIES.map(
    (ability): ColumnSettings => ({
      ...ability,
      sortable: true,
      type: 'checkbox',
      renderValue: CheckedValue,
    })
  ),
];

const SuperAdmins = (): React.ReactElement => (
  <Box mt={5}>
    <div className="alert alert-info" role="alert">
      New admin users get emailed the reset password link immediately so they can set a password for
      their admin user
    </div>
    <EditableTable
      basePath="/v1/super-admins"
      defaultSortKey="email"
      columns={columns}
      identifier="super-admins"
    />
  </Box>
);

export default SuperAdmins;
